import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@mui/material';
import { FilledPersonIcon, GroupIcon } from 'components/elements/Icons';

function UserAvatar({ participants, initials }) {
  return <Avatar>{initials || (participants.length > 1 ? <GroupIcon /> : <FilledPersonIcon />)}</Avatar>;
}

UserAvatar.propTypes = {
  participants: PropTypes.arrayOf(PropTypes.any),
  initials: PropTypes.string,
};

UserAvatar.defaultProps = {
  participants: [],
  initials: '',
};

export default UserAvatar;
